import { mediaSource } from '../shared/mediaSource';
import MediaImage from './MediaImage';
import { useEffect, useRef, useState } from 'react';
import cdoBeing from '../cdo/cdoBeing.js';
import cdoPlace from '../cdo/cdoPlace.js';

export default function TemplateCatalogCard({ record, kind, active, onSelect, subtitle }) {
  const button = useRef(null);
  const [image, setImage] = useState('');
  const [visible, setVisible] = useState(false);
  const providedSource = mediaSource(record, 'card');

  useEffect(() => {
    if (!active || visible) return;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: '160px' });
    observer.observe(button.current);
    return () => observer.disconnect();
  }, [active, visible]);

  useEffect(() => {
    if (!active || !visible) return;
    let current = true;
    setImage('');
    if (providedSource) {
      setImage(providedSource);
    } else if (kind === 'Being' || kind === 'Place') {
      const loadImage = kind === 'Place' ? cdoPlace.selectApproachImage : cdoBeing.selectPortraitImage;
      loadImage(record.idEntity, (error, saved) => {
        if (current && !error && mediaSource(saved)) {
          setImage(mediaSource(saved, 'card'));
        }
      });
    }
    return () => { current = false; };
  }, [active, visible, kind, record.idEntity, providedSource]);

  return <button ref={button} type="button" className="template-card" data-template-id={record.idEntity} aria-label={record.name} onClick={onSelect}>
    <span className="template-card-thumbnail" aria-hidden="true">
      {image ? <MediaImage src={image} alt="" loading="lazy" onError={() => setImage('')} />
        : <i className={kind === 'Being' ? 'bi bi-person-bounding-box' : kind === 'Place' ? 'bi bi-geo-alt' : 'bi bi-box-seam'} />}
    </span>
    <span className="template-card-body">
      <span className="template-card-name">{record.name}</span>
      {subtitle && <span className="template-card-subtitle">{subtitle}</span>}
      {record.description && <span className="template-card-description">{record.description}</span>}
    </span>
  </button>;
}
